import { gate } from 'hub-http/gates';
const PERSONALIZATION = gate('Permissions:Personalize');
const AI_EDITOR_EXPERIMENT = gate('PageEditorAIEditingExperiment');
const WORKFLOWS_MODERN_EDITOR = gate('Workflows:ModernEditor');
const CONTENT_STAGING_BUFFER_APPROACH = gate('ContentStaging:BufferApproach');
const PAGES_BREEZE_ASSISTANT_LANDING_PAGE_SKILL = gate('Pages::BreezeAssistant::LandingPageSkill');
const EDITOR_V2_MULTILANG = gate('ContentEditor:V2:MultiLangVariantPlugin');
const NEW_PAGE_CREATION_FLOW = gate('E2.0:NewPageCreationFlow');
const SOFT_DELETE_PAGES = gate('AdminAutomation::PocSoftDeletePages');
const EDITOR_V2_SITE_PAGES = gate('Pages::E2::WebsitePagesEditingAndManagement');
const EDITOR_TWO_DOT_O_OPTIN = gate('LandingPages:EditorTwoDotO:Optin');
export const Gates = {
  PERSONALIZATION,
  AI_EDITOR_EXPERIMENT,
  WORKFLOWS_MODERN_EDITOR,
  CONTENT_STAGING_BUFFER_APPROACH,
  PAGES_BREEZE_ASSISTANT_LANDING_PAGE_SKILL,
  EDITOR_V2_MULTILANG,
  NEW_PAGE_CREATION_FLOW,
  SOFT_DELETE_PAGES,
  EDITOR_V2_SITE_PAGES,
  EDITOR_TWO_DOT_O_OPTIN
};